import React from 'react';
import './placeHeader.css';

export type PageTab = 'dashboard' | 'settings';

export interface PageTabsProps {
  active: PageTab;
  /** The Dashboard tab: its address and the in-app move. */
  dashboard: { href?: string; onOpen: () => void };
  /** The Settings tab — only for someone who may read the settings. */
  settings?: { href?: string; onOpen: () => void } | null;
}

const plainClick = (e: React.MouseEvent) => !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0);

/**
 * Dashboard | Settings under an account's or a location's title. The same
 * row on the dashboard and on its settings, so each is one tap from the
 * other. With no Settings to offer there is nothing to switch between, and
 * the row is left out.
 */
export const PageTabs: React.FC<PageTabsProps> = ({ active, dashboard, settings }) => {
  if (!settings) return null;
  const tab = (id: PageTab, label: string, target: { href?: string; onOpen: () => void }) =>
    active === id ? (
      <span className="ph-tab" aria-current="page" data-testid={`page-tab-${id}`}>
        {label}
      </span>
    ) : (
      <a
        className="ph-tab"
        href={target.href ?? '#'}
        data-testid={`page-tab-${id}`}
        onClick={(e) => {
          if (target.href && !plainClick(e)) return;
          e.preventDefault();
          target.onOpen();
        }}
      >
        {label}
      </a>
    );
  return (
    <nav aria-label="Page" className="ph-tabs">
      {tab('dashboard', 'Dashboard', dashboard)}
      {tab('settings', 'Settings', settings)}
    </nav>
  );
};

export default PageTabs;
